import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState, useCallback, memo, useMemo, Suspense } from "react";
import { 
//makeStyles,
Box, FormControl, FormHelperText, FormLabel, Hidden } from "@material-ui/core";
import { DataTable } from "@ploy-ui/core";
import { identityRecordOfFieldEditorOptions } from "@ploy-ui/form-fields";
import { identity } from "@ploy-ui/form-fields";
import { FormattedDate } from "react-intl";
import { Cells } from "@ploy-ui/core";
import { TextLiteral } from "./literals";
const emptyArray = [];
const SearchSelectListInternal = memo((props) => {
    const { items: defaultItems = emptyArray, getItemSuggestions, getItemValue = identity, onSelectItem, name: fieldName, value: fieldValue, setFieldValue, label, className, pending } = props;
    //const classes = useStyles(props);
    const [itemSuggestions, setItemSuggestions] = useState(null);
    const [internalLoading, setInternalLoading] = useState(false);
    useEffect(() => {
        if (getItemSuggestions) {
            const fetchItems = async () => {
                const newItems = await getItemSuggestions("");
                setItemSuggestions(newItems);
                setInternalLoading(false);
            };
            setInternalLoading(true);
            fetchItems();
        }
    }, [getItemSuggestions]);
    const loading = pending || internalLoading;
    const onChange = useCallback(item => {
        if (onSelectItem)
            onSelectItem(item);
        setFieldValue(fieldName, getItemValue(item));
    }, [setFieldValue, fieldName, getItemValue, onSelectItem]);
    const remappedItems = useMemo(() => {
        const items = itemSuggestions && itemSuggestions.length > 0
            ? itemSuggestions
            : defaultItems;
        return items.map(i => {
            return {
                ...i,
                CreatedDate: new Date(Date.parse(i["CreatedDate"]))
            };
        });
    }, [defaultItems, itemSuggestions]);
    const mappedSelectedItems = useMemo(() => {
        return !fieldValue
            ? remappedItems
            : remappedItems.map(i => {
                return {
                    ...i,
                    tableData: {
                        checked: getItemValue(i) === fieldValue
                    }
                };
            });
    }, [fieldValue, getItemValue, remappedItems]);
    const columnSettings = useMemo(() => [
        {
            field: "ProductName",
            render: row => (_jsxs("div", { children: [_jsx(Box, { fontWeight: "fontWeightBold", children: row["ProductName"] }), _jsx(Box, { children: row["CarBrandAndModel"] })] }))
        },
        {
            field: "CreatedDate",
            render: row => (_jsx(FormattedDate, { value: row["CreatedDate"], format: "short" }))
        },
        {
            field: "DocumentStatusNameExternal",
            render: row => (_jsxs(_Fragment, { children: [_jsx(Hidden, { lgUp: true, smDown: true, children: _jsx(Cells.ColoredStatus, { rowData: row, statusKey: "ApplicationStatusID", mr: 1 }) }), _jsx(Hidden, { only: "md", children: _jsx(Cells.ColoredStatus, { rowData: row, statusKey: "ApplicationStatusID", mr: 1, children: row["DocumentStatusNameExternal"] }) })] }))
        }
    ].map(c => ({ ...c, cellStyle: { padding: "12px 6px" } })), []);
    const options = {
        selection: true,
        showFirstLastPageButtons: false,
        emptyRowsWhenPaging: false
    };
    const onRowClick = useCallback((e, rowData) => onChange(rowData), [onChange]);
    const onSelectionChange = useCallback(rows => {
        let itemToSet = null;
        if (rows.length > 0) {
            const [first, second = null] = rows;
            itemToSet = first;
            if (second && fieldValue && getItemValue(first) === fieldValue) {
                itemToSet = second;
            }
        }
        onChange(itemToSet);
    }, [fieldValue, getItemValue, onChange]);
    const error = "";
    return (_jsxs(FormControl, { variant: "standard", className: className, fullWidth: true, children: [label && _jsx(FormLabel, { children: label }), _jsx(Suspense, { fallback: null, children: _jsx(DataTable, { isLoading: loading, columns: columnSettings, data: mappedSelectedItems, onRowClick: onRowClick, onSelectionChange: onSelectionChange, options: options, components: {
                        Header: () => null,
                        Toolbar: () => null
                    } }) }), mappedSelectedItems.length === 0 && (_jsx(FormHelperText, { children: "Ingen resultat" })), error && _jsx(FormHelperText, { error: true, children: error })] }));
});
const SearchSelectList = (props) => {
    const { form, field, ...rest } = props;
    const { name, value } = field;
    const { setFieldValue } = form;
    return props.disabled ? (_jsx(TextLiteral, { ...props, literalVariant: "plain" })) : (_jsx(SearchSelectListInternal, { ...rest, name: name, value: value, setFieldValue: setFieldValue }));
};
SearchSelectList.displayName = "DploySearchSelectList";
export const EditorSearchSelectFields = identityRecordOfFieldEditorOptions({
    SearchSelectField: {}
});
export { SearchSelectList };
//# sourceMappingURL=SearchSelectList.js.map